export default `---
slug: austria
country: Austria
countryCode: AUT
continent: Europe
year: 2016
title: "Austria"
description: "Vienna, Salzburg, the Alps — Mozart and Schnitzel."
thumbnail: /images/travels/AUT/austria_thumb.jpg
relatedLinks: []
---
![austria](/images/travels/AUT/austria_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Austria and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
